



















































import { Component, Mixins } from "vue-property-decorator";
import { Mutation } from "vuex-class";
import CurrencySelect from "basis/components/setting/CurrencySelect.vue";
import ColorSelect from "basis/components/setting/ColorSelect.vue";
import mixins from "@/mixins";
import { VERSION } from "@/constants";

@Component({
  components: {
    CurrencySelect,
    ColorSelect
  }
})
class SettingsPage extends Mixins(mixins.page) {
  @Mutation("app/SET_SETTINGS") setSettings;

  sheet = false;

  needAuth = false;

  version = VERSION;

  get title() {
    return this.$t("common.settings") as string;
  }

  get navbarAnimationEnabled() {
    return this.settings.navbarAnimationEnabled;
  }

  set navbarAnimationEnabled(val) {
    this.setSettings({ ...this.settings, navbarAnimationEnabled: val });
  }

  get hideTinyAssets() {
    return this.settings.hideTinyAssets;
  }

  set hideTinyAssets(value) {
    this.setSettings({ ...this.settings, hideTinyAssets: value });
  }

  get isDark() {
    return this.settings.dark;
  }

  set isDark(value) {
    this.setSettings({ ...this.settings, dark: value });
    this.setProperties();
    this.$vuetify.theme.dark = value;
  }
}
export default SettingsPage;
